import type WorkflowFormData from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/FormData/WorkflowFormData';
import * as React from 'react';

export type WorkflowDraftContextValue = {
	readonly draft: WorkflowFormData;
	readonly setDraft: React.Dispatch<React.SetStateAction<WorkflowFormData>>;
	/** Why the last save was refused, shown above the form; null when nothing was refused. */
	readonly refusalMessage: string | null;
	readonly setRefusalMessage: React.Dispatch<React.SetStateAction<string | null>>;
};

const WorkflowDraftContext = React.createContext<WorkflowDraftContextValue | null>(null);

export default WorkflowDraftContext;
